/**
 * Acquisto periodico (Seal) nella pagina prodotto.
 * La pagina ha due widget Seal (desktop e mobile) fuori dal form del carrello:
 * il tema legge il primo input[name="selling_plan"], spesso quello del widget
 * nascosto e vuoto. Qui si copia il piano del widget visibile su tutti gli
 * input e si aggiorna il prezzo principale.
 */
(function () {
  function isVisible(el) {
    return !!(el && el.getClientRects().length);
  }

  function visibleWidget() {
    var inputs = document.querySelectorAll('input[data-sls-selling_plan][name="selling_plan"]');
    for (var i = 0; i < inputs.length; i++) {
      var box = inputs[i].closest('.sealsubs-target-element') || inputs[i].parentElement;
      if (isVisible(box)) return box;
    }
    return null;
  }

  function selectedPrice(widget) {
    var radio = widget.querySelector('input.sls-option:checked');
    var option = radio && radio.closest('.sls-option-container');
    var price = option && option.querySelector('.sls-total-price');
    return price ? price.textContent.trim() : '';
  }

  function updatePrice(planId, sealPrice) {
    var amount = (sealPrice.match(/\d[\d.,]*/) || [])[0];
    document.querySelectorAll('.xo-product-info-content__price .xo-price__item[xo-price]:not(.xo-price__item--del)').forEach(function (el) {
      var current = el.textContent.trim();
      if (!el.hasAttribute('data-respet-original') || current !== el.getAttribute('data-respet-shown')) {
        el.setAttribute('data-respet-original', current);
      }
      var original = el.getAttribute('data-respet-original');
      var next = planId && amount ? original.replace(/\d[\d.,]*/, amount) : original;
      el.textContent = next;
      el.setAttribute('data-respet-shown', next);
    });
  }

  function sync() {
    var widget = visibleWidget();
    if (!widget) return;
    var own = widget.querySelector('input[data-sls-selling_plan][name="selling_plan"]');
    var planId = own ? own.value : '';
    document.querySelectorAll('input[name="selling_plan"]').forEach(function (input) {
      if (input !== own) input.value = planId;
    });
    updatePrice(planId, selectedPrice(widget));
  }

  function syncSoon() {
    window.setTimeout(sync, 60);
    window.setTimeout(sync, 500);
    window.setTimeout(sync, 1500);
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.target.closest('xo-cart-add')) sync();
      else syncSoon();
    },
    true
  );
  document.addEventListener('change', syncSoon, true);
  document.addEventListener('sealsubs:selling_plan_changed', syncSoon);
  window.addEventListener('load', syncSoon);
})();
